export default __webpack_public_path__ + "static/media/over-axle-size.8b505e65.svg";